import { APP_TYPES } from '@config';
import { mergeDeep } from '@services/helper.service';
import {
  SET_SAFETY_MINUTE,
  SET_REBAR_DESIGN,
  SET_EUROCODE_PLUS_FIRE_MINUTE,
  SET_DESIGN,
  SET_DESIGN_TYPE,
  SET_SAFETY_FIRE_ATTACK,
  SET_MAXIMUM_DEVIATION_ACTIVE,
  SET_MAXIMUM_DEVIATION_VALUE,
  SET_CHECK_PROFILE_RESISTANCE_ACTIVE,
  SET_DESIGN_FIXED_ANCHORAGE_DEPTH_SPECIFY,
  SET_DESIGN_FIXED_ANCHORAGE_DEPTH_FIXED_ANCHORAGE_HEF,
  SET_DESIGN_LOADS_DESIGN_VALUE,
  SET_DESIGN_LOADS_CHARACTERISTICS_VALUE,
  SET_DESIGN_STATE,
  RESET_DESIGN_STATE,
  SET_DESIGN_EMBEDMENT_DEPTH_OPTION,
  SET_WORKING_LIFE_VALUE,
  SET_CLADDING_COMBINATIONS
} from './actions';

export const CalculationTypes = {
  // CEN: 'cen',
  // CEN_TYPE_ONE: 'cenTypeOne',
  // CEN_TYPE_TWO: 'cenTypeTwo',
  // ETAG: 'etag',
  // ETAG_TYPE_ONE: 'etagTypeOne',
  // ETAG_TYPE_TWO: 'etagTypeTwo',
  FIRE: 'fire',
  SEISMIC: 'seismic',
  SEISMIC_PERFORMANCE_CATEGORY_C1: 'SEISMIC_PERFORMANCE_CATEGORY_C1',
  SEISMIC_PERFORMANCE_CATEGORY_C2: 'SEISMIC_PERFORMANCE_CATEGORY_C2',

  EN1992: 'EN1992-4:2017',
  EN1992_TYPE_ONE: 'EN1992-4:2017_type-one',
  EN1992_TYPE_TWO: 'EN1992-4:2017_type-two',
  
  EN1992_TYPE_NAILS: 'EN1992-4:2017_type_nails'
};

export const EmbedmentOptions = {
  standard: "Standard",
  d10: "10d",
  d12: "12d",
  d16: "16d",
  d20: "20d",
  imposed_value: "imposed_value"
};

export const initState = {
  [APP_TYPES.GENERAL_CALCULATION]: {
    loads: {
      design: '',
      characteristics: ''
    },
    fixedAnchorageDepth: {
      specify: false,
      fixedAnchorageHef: 60.00,
      embedmentOption: EmbedmentOptions.standard
    },
    workingLife: 50
  },

  [APP_TYPES.BRACKET_ATTACHMENT]: {
    design: CalculationTypes.EN1992,
    designType: CalculationTypes.EN1992_TYPE_ONE,

    // Fire calculation design
    minute: '30',
    fireAttack: 'one_side',
    fixedAnchorageDepth: {
      specify: false,
      fixedAnchorageHef: 60.00,
      embedmentOption: EmbedmentOptions.standard
    }
  },

  [APP_TYPES.SAFETY_BARRIER]: {
    design: CalculationTypes.EN1992,
    designType: CalculationTypes.EN1992_TYPE_ONE,

    // Fire calculation design
    minute: '30',
    fireAttack: 'one_side',

    checkProfileResistance: false,
    maximumDeviation: {
      active: false,
      value: 1/100
    },
    fixedAnchorageDepth: {
      specify: false,
      fixedAnchorageHef: 60.00,
      embedmentOption: EmbedmentOptions.standard
    },
    claddingCombinations: {
      firstOption: true,
      secondOption: false
    }
  },

  [APP_TYPES.REBAR_REINFORCEMENT]: {
    design: 'eurocode-2',
    eurocodePlusFireMinute: 30
  },
  
  [APP_TYPES.WOOD_CONNECTION]: {
    design: CalculationTypes.EN1992,
    designType: CalculationTypes.EN1992_TYPE_NAILS,
    fixedAnchorageDepth: {
      specify: false,
      fixedAnchorageHef: 60.00,
      embedmentOption: EmbedmentOptions.standard
    }
    
  }
};

const design = (state = mergeDeep({}, initState), action) => {
  switch (action.type) {
    case RESET_DESIGN_STATE: {
      return mergeDeep({}, initState);
    }
    case SET_DESIGN_STATE: {
      return action.state;
    }
    case SET_REBAR_DESIGN: {
      return mergeDeep({}, state, {
        [action.appType]: {
          design: action.value
        }
      });
    }
    case SET_EUROCODE_PLUS_FIRE_MINUTE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          eurocodePlusFireMinute: action.value
        }
      });
    }

    case SET_DESIGN: {
      return mergeDeep({}, state, {
        [action.appType]: {
          design: action.value
        }
      });
    }
    case SET_DESIGN_TYPE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          designType: action.value
        }
      });
    }
    case SET_SAFETY_MINUTE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          minute: action.value
        }
      });
    }
    case SET_SAFETY_FIRE_ATTACK: {
      return mergeDeep({}, state, {
        [action.appType]: {
          fireAttack: action.value
        }
      });
    }
    case SET_CHECK_PROFILE_RESISTANCE_ACTIVE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          checkProfileResistance: action.value
        }
      });
    }
    case SET_MAXIMUM_DEVIATION_ACTIVE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          maximumDeviation: {
            active: action.value
          }
        }
      });
    }
    case SET_MAXIMUM_DEVIATION_VALUE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          maximumDeviation: {
            value: action.value
          }
        }
      });
    }

    case SET_DESIGN_FIXED_ANCHORAGE_DEPTH_SPECIFY: {
      return mergeDeep({}, state, {
        [action.appType]: {
          fixedAnchorageDepth: {
            specify: action.value
          }
        }
      });
    }
    case SET_DESIGN_FIXED_ANCHORAGE_DEPTH_FIXED_ANCHORAGE_HEF: {
      return mergeDeep({}, state, {
        [action.appType]: {
          fixedAnchorageDepth: {
            fixedAnchorageHef: action.value
          }
        }
      });
    }
    case SET_DESIGN_EMBEDMENT_DEPTH_OPTION: {
      return mergeDeep({}, state, {
        [action.appType]: {
          fixedAnchorageDepth: {
            embedmentOption: action.value
          }
        }
      });
    }
    case SET_DESIGN_LOADS_DESIGN_VALUE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          loads: {
            design: action.value
          }
        }
      });
    }
    case SET_DESIGN_LOADS_CHARACTERISTICS_VALUE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          loads: {
            characteristics: action.value
          }
        }
      });
    }
    case SET_WORKING_LIFE_VALUE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          workingLife: action.value
        }
      });
    }
    case SET_CLADDING_COMBINATIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          claddingCombinations: {
            firstOption: action.firstOption,
            secondOption: action.secondOption
          }
        }
      });
    }
    default: {
      return state;
    }
  }
};

export default design;



// WEBPACK FOOTER //
// ./src/reducers/selectors/design/index.js